import { render, staticRenderFns } from "./MediaInfo.vue?vue&type=template&id=87eaf044&scoped=true"
import script from "./MediaInfo.vue?vue&type=script&lang=ts"
export * from "./MediaInfo.vue?vue&type=script&lang=ts"
import style0 from "./MediaInfo.vue?vue&type=style&index=0&id=87eaf044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eaf044",
  null
  
)

export default component.exports